import React from 'react';
import { ToastContainer } from 'react-toastify';
import HeroSection from 'components/PartnerPage/HeroSection';
import { EmailInputProvider } from 'contexts/EmailInputContext';

export default function ShipcampsLeadGenLandingPage() {

  return (
    <EmailInputProvider
    buttonText={'Submit'}
    >
      <ToastContainer />
      {/* Background image container with responsive height */}
      <div>
        <HeroSection
          heading={
            <span className="text-[#000000]">Camp Season 2026 is Coming!</span>
          }
          subheading={
            <span className="text-[#000000] font-normal">
              <p>Registration will be open February 2026</p><br />
              <p>Sign up to be notified when 2026 Ship Camps registration is available</p>
            </span>
          }
          buttonText="Submit"
          buttonBgColor="#000000"
        />
      </div>
    </EmailInputProvider>
  );
}
